import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl, priceValue, productName } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  className?: string;
}
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-8 py-4 text-sm sm:px-10 sm:py-5 sm:text-base' : 'px-6 py-3.5 text-sm';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: productName,
      value: priceValue,
      currency: 'USD'
    });
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-full border border-gold-text/30 bg-gold font-sans font-extrabold uppercase tracking-wide text-navy shadow-lg shadow-gold/40 transition-[background-color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:bg-gold-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy active:translate-y-0 ${sizing} ${className}`} data-id="element-71" data-mp="vaqwiwmop1jf">
      <span data-id="element-72" data-mp="3exktnbhz5tlt">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.5} aria-hidden="true" data-id="element-73" data-mp="3ew9gwm6jxbik" />
    </a>;
}